const addCookie = (name, value, days) => {
    let expires = '';
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '')  + expires + '; path=/';
}

const getCookie = (name) => {
    let nameEQ = name + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

const eraseCookie = (name) => {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// general session 
let firstSession = getCookie('first_session');
let sessionKey = sessionStorage.getItem('key');

let secondSession = false;

if (!sessionKey && firstSession == 'false') {
    secondSession = true;
} else {
    addCookie('first_session', 'false', 30);
    sessionStorage.setItem('key', 'value');
}

// hc: home copy
let hc_firstSession = getCookie('hc_first_session');
let hc_sessionKey = sessionStorage.getItem('hc_key');

let hc_secondSession = false;

if (!hc_sessionKey && hc_firstSession == 'false') {
    hc_secondSession = true;
} else {
    addCookie('hc_first_session', 'false', 30);
    sessionStorage.setItem('hc_key', 'value');
}